import { Vector3 } from 'three';
import { defaultConfig } from '@verybigthings/vbt-webvr-framework';
const config = Object.assign(Object.assign({}, defaultConfig), { 
    // isDebug: true,
    isDebug: false, zSpaceEnabled: document.location.href.toLocaleLowerCase().indexOf('zspace') > -1, webVREnabled: document.location.href.toLocaleLowerCase().indexOf('zspace') < 0, pointerMinDistance: 0.1, showController: true, pointerMaxDistance: 100, positionalAudioEnabled: false, zSpaceFramebufferScaleFactor: 1.0 });
const zSpaceConfig = {
    ppe: {
        // pointPos: new Vector3(0, 16, 32),
        viewerScale: 31,
        zSpacePosition: new Vector3(-0.05, -11.84, 15),
        yaw: 0.006,
        pitch: 1.27,
    },
    lobby: {
        // pointPos: new Vector3(0, -8, -9),
        viewerScale: 67,
        zSpacePosition: new Vector3(0, -15, -9),
        yaw: 0,
        pitch: 1.57,
    },
    petri: {
        viewerScale: 31,
        zSpacePosition: new Vector3(-41.15, -14.81, 6.75),
        yaw: 1.0677,
        pitch: 1.272,
    },
    micropipette: {
        viewerScale: 31,
        zSpacePosition: new Vector3(-23.2075, -14.879, -8.9),
        yaw: 0.535,
        pitch: 1.27,
    },
    serological: {
        viewerScale: 31,
        zSpacePosition: new Vector3(0, -15, -17),
        yaw: 0,
        pitch: 1.34,
    },
    molar: {
        viewerScale: 31,
        zSpacePosition: new Vector3(21.55, -15.345, -7.07),
        yaw: -0.53,
        pitch: 1.34,
    },
    spectrophotometer: {
        viewerScale: 31,
        zSpacePosition: new Vector3(39.75, -14.87, 10.49),
        yaw: -1.06,
        pitch: 1.45,
    }
};
export { config, zSpaceConfig };
